import { useState } from 'react'

import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { SupportContent } from 'src/shared/features/support/components/support-content'

interface SupportDialogProps {
  trigger: React.ReactNode
}

export const SupportDialog = ({ trigger }: SupportDialogProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ResponsivePopup
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={trigger}
      // mobileRoute="/support"
      title="Contact support"
    >
      <SupportContent onClose={() => setIsOpen(false)} />
    </ResponsivePopup>
  )
}
